// Imports:

// Styles:
import 'bootstrap/scss/bootstrap.scss';

// Main.scss should always be last, otherwise your styles can be overwrite by styles from libraries
import '../scss/main.scss';


// Common libraries: 
import $ from 'jquery';
window.jQuery = $;
window.$ = $;


// Popper - neccessary for bootstrap
import Popper from 'popper.js/dist/umd/popper.js';
window.Popper = Popper;

import 'bootstrap';

import {
    TweenMax,
    TimelineMax,
    AttrPlugin,
    CSSPlugin,
    Bounce
} from "gsap/all";

const activated = [
    TweenMax,
    TimelineMax,
    AttrPlugin,
    CSSPlugin,
    Bounce
];

import ScrollMagic from 'scrollmagic';
window.ScrollMagic = ScrollMagic;

// import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap.js';

// import 'imports-loader?define=>false!gsap/src/minified/plugins/ScrollToPlugin.min.js';

/* Scroll Magic Scens Plugin */
import Scens from './plugins/PluginScrollmagicScens.js';

const controller = new ScrollMagic.Controller();

window.scens = new Scens(controller);

// Plugins
import './plugins/PluginLoadDependecies';
import './plugins/PluginLazyLoad';
import './plugins/PluginOutline';
import './plugins/PluginDeviceType';
import './plugins/PluginBlockEmbed';
import './plugins/PluginAnalytics';
import cookiesController from './plugins/PluginCookies';
// Create CookiesController instance
window.CookiesController = cookiesController;

import converSVG from './plugins/converSVG.js';

window.svg = new converSVG();
window.svg.converSVG();

/* Sticky */
import Sticky from 'sticky-js/dist/sticky.min.js';


// Components:
// 

// Script to handle menuPages
// Handle show/hide of menu with all pages

// Get menu element
let BwMenuPages = $("[data-item='BW-navigation-menu']");

// Check if menu exists
if (BwMenuPages.length > 0) {
    // Show/hide on button with menu icon
    $("[data-item='BW-navigation-button']").on("click", () => {
        if (BwMenuPages.length > 0) {
            // Check if menu is visible
            if (BwMenuPages.hasClass("visible") !== true) {
                // If true -> animate show
                BwMenuPages.addClass("visible");
                BwMenuPages.animate({ "opacity": "1" }, 300);
            }
            else {
                // If false -> animate hide
                BwMenuPages.animate({ "opacity": "0" }, 300, function () {
                    BwMenuPages.removeClass("visible");
                });
            }
        }
    });

    // Hide on button 'X" click
    $("[data-action='BW-navigation-hide']").on("click", () => {
        if (BwMenuPages.length > 0) {
            // Animate hide
            BwMenuPages.animate({ "opacity": "0" }, 300, function () {
                BwMenuPages.removeClass("visible");
            });
        }
    });
}

const header = document.querySelector("header");

// Remove preload class on load
window.addEventListener('load', () => {

    var sticky = new Sticky('[data-stick="true"]');

    /* scroll magic scens */
    const animation = document.querySelector('[data-item="animation"]');

    if (animation) {
        window.scens.animation();
    }
    setTimeout(function () {
        // Remove class that prevent transition
        const preload = document.querySelector("body");
        preload.classList.remove("preload");

        // hide loader
        let loader = document.querySelector("[data-item='loader']");
        let loaderStyle = document.querySelector("[data-item='loader-styles']");

        loader.parentNode.removeChild(loader);

        loaderStyle.parentNode.removeChild(loaderStyle);

    }, 100);

    let social = document.querySelector("[data-item='section-top-social']");


    if (document.body.scrollTop > 1 || document.documentElement.scrollTop > 1) {
        header.classList.add("fixed");

        if (social) {
            social.style.opacity = 0;
        }
    } else {
        header.classList.remove("fixed");

        if (social) {
            social.style.opacity = 1;
        }
    }
});

window.addEventListener('scroll', function () {
    const show = header.querySelector(".show");
    let social = document.querySelector("[data-item='section-top-social']");

    if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
        header.classList.add("fixed");

        if (social) {
            social.style.opacity = 0;
        }

        if (show) {
            show.classList.remove("show");
        }

    } else {
        header.classList.remove("fixed");

        if (social) {
            social.style.opacity = 1;
        }
    }

});